<template>
    <div ref="div">
        <label class="col-12 m-0">
            <v-row v-if="progress === 0" class="text-center">
                <v-col cols="12">
                    <img src="/images/_SVGs/environmental/upload-file.svg" alt="PDF" width="40" height="40"/>
                </v-col>
                <v-col cols="12">
                   {{$t('input-file.subtitle')}}
                </v-col>

                <v-col cols="12">
                    <a class="btn btn-primary" style="color:#fff;">
                        {{$t('input-file.select-file')}}
                    </a>
                </v-col>
            </v-row>

            <v-row v-if="progress > 0 && progress < 100" class="text-center">
                <v-col cols="12">
                   <b> {{ progress }}% </b>
                </v-col>
            </v-row>

            <input ref="input" type="file" :accept="accept" @change="onFileChange"/>
        </label>

        <v-row v-if="progress === 100" class="text-center">
            <v-col cols="12">
                <p class="file-name">{{ name }}
                    <svg style="cursor: pointer;" v-if="progress === 100" @click="removeFile" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                        <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z" fill="red"></path>
                        <path d="M0 0h24v24H0z" fill="none"></path>
                    </svg>
                </p>
            </v-col>
        </v-row>
        <pre>{{ error }}</pre>
    </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: 'Drag and Drop'
    },
    accept: {
      type: String,
      default: 'application/pdf' // image/png, image/jpeg, application/pdf, application/vnd.ms-excel
    },
    clear: {
      type: Boolean
    }
  },
  data () {
    return {
      file: null,
      name: null,
      progress: 0,
      error: null,
      dragAndDropCapable: true
    }
  },
  watch: {
    clear: {
        handler: function (newValue, oldValue) {
            if(newValue) {
                this.removeFile();
            }
        },
    }
  },
  mounted () {
    const { div } = this.$refs
    // Determine if drag and drop functionality is capable in the browser
    this.dragAndDropCapable = this.isDragAndDropCapable()
    if(this.dragAndDropCapable) {
      ['drag', 'dragstart', 'dragend', 'dragover', 'dragenter', 'dragleave', 'drop'].forEach( event => {
        document.body.addEventListener(event, e => {
          e.preventDefault()
          e.stopPropagation()
          // if (e.type === 'dragover') {
          //   console.log('dragover', div) // eslint-disable-line
          //   div.classList.add('dragover')
          // }
        })
      })
      div.addEventListener('drop', e => {
        this.onFileChange(e)
      })
    }
  },
  methods: {
    isDragAndDropCapable () {
      const { div } = this.$refs
      return (('draggable' in div)
        || ('ondragstart' in div && 'ondrop' in div))
        && 'FormData' in window
        && 'FileReader' in window
    },
    onFileChange(e) {
      // e.preventDefault()
      const files = e.target.files || e.dataTransfer.files
       if (!files.length)
         return
       this.createFile(files[0])
     },
    createFile(file) {
      const reader = new FileReader()
      const vm = this
      this.$emit('loadUpload', file)
      reader.onprogress = e => {
        if (e.lengthComputable) {
          vm.trackProgress(e.loaded, e.total)
        }
      }
      reader.onloadend = e => {
        const { error } = e.target
        if (error != null) {
          switch (error.code) {
            case error.ENCODING_ERR:
              vm.error = this.$t('input-file.error1')
              break
            case error.NOT_FOUND_ERR:
              vm.error = this.$t('input-file.error2')
              break
            case error.NOT_READABLE_ERR:
              vm.error = this.$t('input-file.error3')
              break
            case error.SECURITY_ERR:
              vm.error = this.$t('input-file.error4')
              break
            default:
              vm.error = this.$t('input-file.error5')
          }
        }
        vm.trackProgress(e.loaded, e.total)
      }
      reader.onload = e => {
        const { result } = e.target
        vm.file = result
        vm.name = file.name
      }
      reader.readAsBinaryString(file)
    },
    trackProgress (loaded, total) {
      this.progress = parseInt(((loaded / total) * 100), 10)
    },
    removeFile () {
      this.file = null;
      this.name = null;
      this.progress = 0;
      this.error = null;
      this.dragAndDropCapable = true;
      this.$emit('loadUpload', null);
      if(this.$refs.input) {
          this.$refs.input.value = "";
      }
    }
  }
}
</script>

<style scoped>
input[type="file"] {
  display: none;
}
strong,
svg {
  vertical-align: middle;
}
</style>
